import React, { useEffect, useState } from "react";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { useSelector } from "react-redux";
import {
  Box,
  createStyles,
  Flex,
  Grid,
  Loader,
  Text,
  Title,
} from "@mantine/core";
import { NewAddButton } from "../../../components/AddButton/NewAddButton";
import { NotetTypeSvg } from "../../../components/Svgs/NotetTypeSvg";
import { LuListChecks } from "react-icons/lu";
import { NoteCard } from "./NoteCard";
import { useDisclosure } from "@mantine/hooks";
import {
  getAllNoteTypes,
  getFieldTypes,
  getNoteTypes,
} from "../../../services/note";
import { TrackPageView } from "../../../config/mixpanelConfig";
import CustomPagination from "../../../components/Pagination/CustomPagination";
import NoteTypeDrawer from "../../../components/NoteTypeModal/NoteTypeDrawer";
import { useNavigate } from "react-router-dom";
import { MdKeyboardArrowLeft } from "react-icons/md";

const useStyles = createStyles(() => ({
  bgColorClass: {
    width: "100%",
    backgroundColor: "var(--app-bg)",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px",
    margin: "1rem",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "80vh",
  },
}));
const NewNoteType = () => {
  const { classes } = useStyles();
  const { profile } = useSelector((state) => state?.profile);
  const [opened, { open, close }] = useDisclosure(false);
  const { noteTypes, loading } = useSelector((state) => state.note);
  const [currentPage, setCurrentPage] = useState(1);
  // const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    getFieldTypes();
    // getNoteTypes();
    TrackPageView("Note Type");
  }, []);
  useEffect(() => {
    getNoteTypes(currentPage);
    getAllNoteTypes();
  }, [currentPage]);

  const handleAddClick = () => {
    open();
  };

  const handleViewClick = () => {
    open();
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <Box className={classes.bgColorClass}>
      <AppNavbar title="Note Type" profile={profile} />
      <Flex
        align="center"
        gap={5}
        m={10}
        onClick={() => navigate("/home/note")}
        style={{ cursor: "pointer", width: "fit-content" }}
      >
        <MdKeyboardArrowLeft size={30} />
        <Text fw={400} fz={12} c={"var(--app-text)"} ff={"Inter"}>
          Back
        </Text>
      </Flex>
      <Box className={classes.header}>
        <Title order={3}>Note Setting</Title>
        <Flex gap={10} align="center">
          <NewAddButton
            title="Quick Notes"
            icon={<LuListChecks size={20} color="#000" />}
            onClick={() => navigate("/home/activitylibrary")}
           color="var(--app-primary)"
          textColor="var(--app-on-primary)"
            variant="filled"
            borderColor="none"
          />
          <NewAddButton
            title="Add Note Type"
            icon={<NotetTypeSvg />}
            onClick={handleAddClick}
            color="var(--app-primary)"
          textColor="var(--app-on-primary)"
            variant="filled"
            borderColor="none"
          />
        </Flex>
        <NoteTypeDrawer
          title={"New Note Type"}
          // setLoading={setLoading}
          opened={opened}
          close={() => {
            close();
          }}
        />
      </Box>
      <Box className={classes.noteCards}>
        {loading ? (
          <Box className={classes.loader}>
            <Loader size="lg" color="var(--app-primary)" />
          </Box>
        ) : (
          <Grid m={0}>
            {noteTypes?.ntypes?.map((note, i) => (
              <Grid.Col xs={12} sm={6} md={6} lg={4}>
                <NoteCard key={i} note={note} openDrawer={handleViewClick} />
              </Grid.Col>
            ))}
          </Grid>
        )}
      </Box>
      <CustomPagination
        itemsPerPage={10}
        data={noteTypes?.count + 5}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
      />
    </Box>
  );
};

export default NewNoteType;
